<div class="bs" [class.bs--open]="open" [class.bs--invalid]="invalid" [class.bs--disabled]="disabled" (focusout)="onFocusOut($event)">
    <div class="bs__field">
        <input
            #input
            class="bs__input"
            type="text"
            role="combobox"
            autocomplete="off"
            spellcheck="false"
            aria-autocomplete="list"
            [id]="inputId"
            [attr.aria-expanded]="open"
            [attr.aria-controls]="listId"
            [attr.aria-activedescendant]="open && activeIndex >= 0 ? optionId(activeIndex) : null"
            [attr.aria-invalid]="invalid || null"
            [value]="inputText"
            [placeholder]="open ? copy.searchPlaceholder : placeholder"
            [disabled]="disabled"
            (focus)="openList()"
            (click)="openList()"
            (input)="onInput($any($event.target).value)"
            (keydown)="onKeydown($event)"
            data-test="bank-select-input"
        />
        <button type="button" class="bs__toggle" tabindex="-1" [attr.aria-label]="copy.toggle" [disabled]="disabled" (mousedown)="$event.preventDefault()" (click)="toggle()">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="m6 9 6 6 6-6" />
            </svg>
        </button>
    </div>

    <ul *ngIf="open" class="bs__list" role="listbox" [id]="listId" [ngStyle]="panelStyle" (mousedown)="$event.preventDefault()" data-test="bank-select-list">
        <li
            *ngFor="let bank of filtered; let i = index; trackBy: trackByName"
            class="bs__option"
            role="option"
            [id]="optionId(i)"
            [class.bs__option--active]="i === activeIndex"
            [class.bs__option--selected]="bank.name === selected?.name"
            [attr.aria-selected]="bank.name === selected?.name"
            (mousedown)="onOptionMousedown($event, bank)"
            (mouseenter)="activeIndex = i"
            data-test="bank-select-option"
        >
            <span class="bs__code">{{ bank.code || '—' }}</span>
            <span class="bs__name">{{ bank.name }}</span>
            <svg
                *ngIf="bank.name === selected?.name"
                class="bs__check"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.4"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <path d="M20 6 9 17l-5-5" />
            </svg>
        </li>
        <li *ngIf="!filtered.length" class="bs__empty" role="presentation" data-test="bank-select-empty">{{ copy.empty }}</li>
    </ul>
</div>
